import axios from 'axios';
import env from './env';

function fromFirestoreValue(value) {
  if (!value) return null;
  if (Object.prototype.hasOwnProperty.call(value, 'stringValue')) {
    return value.stringValue;
  }
  if (Object.prototype.hasOwnProperty.call(value, 'booleanValue')) {
    return value.booleanValue;
  }
  if (Object.prototype.hasOwnProperty.call(value, 'nullValue')) {
    return null;
  }
  if (value.mapValue && value.mapValue.fields) {
    const out = {};
    Object.keys(value.mapValue.fields).forEach(key => {
      out[key] = fromFirestoreValue(value.mapValue.fields[key]);
    });
    return out;
  }
  return null;
}

export function parseShopfrontHours(document) {
  const fields = (document && document.fields) || {};
  return {
    daysOpen: fromFirestoreValue(fields.daysOpen) || {},
    openingTimes: fromFirestoreValue(fields.openingTimes) || {},
    closingTimes: fromFirestoreValue(fields.closingTimes) || {},
    openingHoursNotes: fromFirestoreValue(fields.openingHoursNotes) || {}
  };
}

export function overlayShopfrontHours(store, shopfront) {
  if (!store || !shopfront) return store;
  return {
    ...store,
    daysOpen: { ...(store.daysOpen || {}), ...(shopfront.daysOpen || {}) },
    openingTimes: { ...(store.openingTimes || {}), ...(shopfront.openingTimes || {}) },
    closingTimes: { ...(store.closingTimes || {}), ...(shopfront.closingTimes || {}) },
    openingHoursNotes: {
      ...(store.openingHoursNotes || {}),
      ...(shopfront.openingHoursNotes || {})
    }
  };
}

export function applySmartbooksHoursToStores(stores, hoursByBoxxId) {
  const out = {};
  Object.keys(stores || {}).forEach(id => {
    out[id] = overlayShopfrontHours(stores[id], hoursByBoxxId && hoursByBoxxId[id]);
  });
  return out;
}

export function hoursNoteForDay(store, day) {
  const note =
    store && store.openingHoursNotes && store.openingHoursNotes[day];
  if (typeof note === 'string' && note.trim()) return note.trim();
  if (
    store &&
    store.walkInOnly &&
    store.walkInOnly[day] &&
    store.daysOpen &&
    store.daysOpen[day]
  ) {
    return '(walk-in only)';
  }
  return '';
}

export async function fetchSmartbooksShopfrontHours() {
  const config = env.smartbooksShopfront || {};
  const storeIds = config.storeIds || {};
  const projectId = config.projectId;
  if (!projectId) return {};

  const results = await Promise.all(
    Object.entries(storeIds).map(async ([boxxStoreId, smartbooksStoreId]) => {
      try {
        const url = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/stores/${smartbooksStoreId}`;
        const { data } = await axios.get(url, { timeout: 8000 });
        return [boxxStoreId, parseShopfrontHours(data)];
      } catch (_) {
        return [boxxStoreId, null];
      }
    })
  );

  const hoursByBoxxId = {};
  results.forEach(([id, hours]) => {
    if (hours) hoursByBoxxId[id] = hours;
  });
  return hoursByBoxxId;
}
